import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import {
  Box, Columns, LoadingModule,
} from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import usePublicationEditionDeadlines from '@hooks/usePublicationEditionDeadlines'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import DeadlinesBlankState from '../../../../components/DeadlinesBlankState'
import generateDeadlineTabItems from '../../../../components/utils/generateDeadlineTabItems'

import TodaysDeadlines from '../TodaysDeadlinesListItem'

const PageContent = () => {
  const { agencyIdParam } = useAgencySelector()

  useLocation()

  const publicationEditionDeadlinesPayload = usePublicationEditionDeadlines({
    filters: {
      days_from_now: '0',
    },
    requestOptions: {
      include_publication_edition_deadlines: true,
      include_publication_edition_publication: true,
      include_publication_logo: true,
      include_unused_editions: false,
    },
    performHttpRequests: true,
  })

  const {
    filteredPublicationEditionDeadlines,
    hasFilteredPublicationEditionDeadlines,
    loading,
  } = publicationEditionDeadlinesPayload

  return (
    <>
      <Helmet>
        <title>Deadlines | Realhub</title>
      </Helmet>

      <PageHeader
        nestedNavigation
        activeTabBarItemKey="deadlines"
        // @ts-expect-error TS2345
        tabBarItems={generateDeadlineTabItems(agencyIdParam)}
        title="Deadlines"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation
              locationKey="agency.agencyDashboard.deadlines.banner"
            />

            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredPublicationEditionDeadlines && <DeadlinesBlankState />}

            {!loading && hasFilteredPublicationEditionDeadlines && (
              <>
                {filteredPublicationEditionDeadlines.map((todaysDeadline, index) => (
                  <TodaysDeadlines todaysDeadline={todaysDeadline} key={index} />
                ))}
              </>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation
              locationKey="agency.agencyDashboard.deadlines.sidebar"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
